/**
 * シリーズ横断Connect提案依頼一覧画面の初期化
 */
export function initMyPageConnect() {
    initNewArrivalAnchor();
    initTaskNoAnchor();
}
/**
 * 新着並び替えaタグの初期化
 */
function initNewArrivalAnchor() {
    const anchor = document.getElementById('my-page-connect-request-new-arrival-sort-anchor');
    if (anchor === null)
        return;
    let desc = 0;
    anchor.addEventListener("click", () => {
        desc = 1 - desc;
        const table = document.getElementById('my-page-connect-request-table');
        const rows = table.rows;
        const n = rows.length;
        for (let i = 1; i < n; i++) {
            let status = Number(rows[i].dataset.status);
            if (status == desc) {
                continue;
            }
            for (let j = i + 1; j < n; j++) {
                status = Number(rows[j].dataset.status);
                if (status == desc) {
                    rows[i].parentNode.insertBefore(rows[j], rows[i]);
                    break;
                }
            }
        }
    });
}
/**
 * 案件No並び替えaタグの初期化
 */
function initTaskNoAnchor() {
    const anchor = document.getElementById('my-page-connect-request-task-no-sort-anchor');
    if (anchor === null)
        return;
    let asc = false;
    anchor.addEventListener("click", () => {
        asc = !asc;
        const table = document.getElementById('my-page-connect-request-table');
        const rows = table.rows;
        const n = rows.length;
        for (let i = n - 1; i > 1; i--) {
            for (let j = 1; j < i; j++) {
                const no1 = Number(rows[j].dataset.taskNo);
                const no2 = Number(rows[j + 1].dataset.taskNo);
                if (asc ? no1 > no2 : no1 < no2) {
                    rows[j].parentElement.insertBefore(rows[j + 1], rows[j]);
                }
            }
        }
    });
}
